import { DEFAULT_PROJECTION_YEARS } from 'datasource/CreatePortfolio/constants';
import ServiceManager from 'services/ServiceManager';

const getInvestmentProjection = (data: any) : any => {
    const payload:any = {
        modelPortfolioId: data.PortfolioId ?? data.modelPortfolioId,
        projectionYears: (data.projectionYears ?? 0) <= 0 ? DEFAULT_PROJECTION_YEARS : +data.projectionYears,
        initialInvestmentAmount: data.InitialInvestmentAmount ?? data.initialInvestment,
        yearlyContributionAmount: data.YearlyContributionAmount ?? data.yearlyPayments ?? 0,
        investmentApplicationId: data?.investmentApplicationId,
    };

    if (data.individualPortfolio) {
        payload.individualPortfolio = data.individualPortfolio;
    }

    if (payload.initialInvestmentAmount > 0 || payload.yearlyContributionAmount > 0) {
        return ServiceManager.customInvestmentService('postData', [payload]);
    }
};

export default getInvestmentProjection;
